import {
  SCHOOLS_ENDPOINT,
  SCHOOLS_MANAGER_ENDPOINT,
  SCHOOLS_STATS_ENDPOINT,
  SCHOOLS_AND_USER_STATS_EXPORT_ENDPOINT,
  SCHOOLS_STUDENTS_STATS_ENDPOINT,
  SCHOOLS_SIMPLE_ENDPOINT,
  SCHOOLS_PETITION_ENDPOINT,
  SCHOOL_RETURNS_BY_SCHOOL,
  SCHOOL_RETURNS,
  SCHOOL_RETURNS_BY_STUDENT,
  SCHOOL_RETURNS_BOOK_UPDATE,
  SCHOOL_RETURNS_PACKAGE_UPDATE,
  SCHOOL_RETURNS_SCHOOL_UPDATE,
  SCHOOL_RETURNS_SUMMARY_UPDATE,
  SCHOOL_RETURNS_EXPORT,
  SCHOOL_TYPES_ENDPOINT,
  SCHOOL_BOOKS_PURCHASE_UPDATE,
  SCHOOL_BOOKS_PURCHASE,
  SCHOOL_BOOKS_PURCHASE_SUMMARY,
  ACCOUNT_ACTIVATE_ADVICE_SCHOOL,
  ACCOUNT_ACTIVATE_ADVICE,
  SCHOOL_SET_BOOK_STATUS,
  SCHOOL_DELETE_FLOW,
  SCHOOL_CREATE_FLOW,
  ALL_SCHOOL_SET_BOOK_STATUS,
  SCHOOL_BYUSER_ENDPOINT,
  SCHOOL_SETTINGS_ENDPOINT,
} from "../Constants/Endpoints";
import { apiCall, apiCallJson, apiCallExportFile } from "../Helpers";
import { apiCallJsonWithFile } from "../Helpers/ApiCall";
import { objectToQueryString } from "../Helpers/utils/utils";


export async function getAllSchoolsListRequest() {
  return await apiCallJson(SCHOOLS_ENDPOINT, "GET", null);
}

export async function getAllSchoolsSimpleRequest() {
  return await apiCallJson(SCHOOLS_SIMPLE_ENDPOINT, "GET", null);
}

export async function getSchoolsListRequest(userId) {
  const endpoint = SCHOOLS_MANAGER_ENDPOINT + `?userId=${userId}`;
  return await apiCallJson(endpoint, "GET", null);
}

export async function getSchoolPetitionnListRequest(userId) {
  const endpoint = SCHOOLS_PETITION_ENDPOINT + `?userId=${userId}`;
  return await apiCallJson(endpoint, "GET", null);
}

export async function exportSchoolAndUserStatsCsvRequest(filename) {
  return await apiCallExportFile(SCHOOLS_AND_USER_STATS_EXPORT_ENDPOINT, "POST", null, filename);
}

export async function getSchoolStatsRequest(schoolId) {
  const endpoint = SCHOOLS_STATS_ENDPOINT + `?schoolId=${schoolId}`;
  return await apiCallJson(endpoint, "GET", null);
}

export async function getSchoolStudentStatsRequest(schoolId) {
  const endpoint = SCHOOLS_STUDENTS_STATS_ENDPOINT + `?schoolId=${schoolId}`;
  return await apiCallJson(endpoint, "GET", null);
}

export async function updateSchoolStatsRequest(schoolId) {
  const endpoint = SCHOOLS_STATS_ENDPOINT + `?schoolId=${schoolId}`;
  return await apiCallJson(endpoint, "POST", null);
}

export async function updateSchoolStudentStatsRequest(schoolId) {
  const endpoint = SCHOOLS_STUDENTS_STATS_ENDPOINT + `?schoolId=${schoolId}`;
  return await apiCallJson(endpoint, "POST", null);
}

export async function postSchoolManagerPetition(userId, body) {
  const endpoint = SCHOOLS_PETITION_ENDPOINT + `?userId=${userId}`;
  return await apiCallJson(endpoint, "POST", body);
}

export async function putSchoolManager(userId, body) {
  const endpoint = SCHOOLS_MANAGER_ENDPOINT + `?userId=${userId}`;
  return await apiCallJson(endpoint, "PUT", body);
}

export async function getSchoolReturnsByIdRequest(id) {
  return await apiCallJson(SCHOOL_RETURNS + `?schoolId=${id}`, "GET", null);
}

export async function getPackageByBarcodeRequest(schoolId, barcode, year) {
  return await apiCallJson(
    SCHOOL_RETURNS_BY_SCHOOL +
    `?schoolId=${schoolId}&barcode=${barcode}&year=${year}`,
    "GET",
    null
  );
}

export async function getPackageByIdRequest(schoolId, id, year) {
  return await apiCallJson(
    SCHOOL_RETURNS_BY_SCHOOL + `?schoolId=${schoolId}&id=${id}&year=${year}`,
    "GET",
    null
  );
}

export async function getBookByISBNRequest(barcode, isbn) {
  return await apiCallJson(
    SCHOOL_RETURNS_BY_STUDENT + `?barcodeId=${barcode}&book.isbn=${isbn}`,
    "GET",
    null
  );
}

export async function updateSchoolRequest(body) {
  return await apiCallJson(SCHOOL_RETURNS_SCHOOL_UPDATE, "PUT", body);
}

export async function updatePackageRequest(body) {
  return await apiCallJson(SCHOOL_RETURNS_PACKAGE_UPDATE, "PUT", body);
}

export async function updateBookRequest(body) {
  return await apiCallJson(SCHOOL_RETURNS_BOOK_UPDATE, "PUT", body);
}

export async function getSummaryRequest(queryString) {
  return await apiCallJson(
    SCHOOL_RETURNS_SUMMARY_UPDATE + queryString,
    "GET",
    null
  );
}

export async function exportBarcodeBooks(schoolId, year) {
  let params = {
    schoolId: schoolId,
    year: year
  };

  let requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    },
  };

  return await apiCall(
    SCHOOL_RETURNS_EXPORT + objectToQueryString(params, true),
    requestOptions,
    "export-barcode-books"
  );
}


export async function getSchoolTypesRequest() {
  return await apiCallJson(SCHOOL_TYPES_ENDPOINT, "GET", null);
}

export async function getSchoolByUserRequest(params) {
  return await apiCallJson(
    SCHOOL_BYUSER_ENDPOINT + objectToQueryString(params, true),
    "GET",
    null
  );
}

export async function updateBookPurchaseRequest(body) {
  return await apiCallJson(SCHOOL_BOOKS_PURCHASE_UPDATE, "PUT", body);
}

export async function getBookPurchaseByISBNRequest(schoolPackageId, isbn) {
  return await apiCallJson(
    SCHOOL_BOOKS_PURCHASE + `?schoolPackageId=${schoolPackageId}&isbn=${isbn}`,
    "GET",
    null
  );
}

export async function getSummaryPurchaseRequest(queryString) {
  return await apiCallJson(
    SCHOOL_BOOKS_PURCHASE_SUMMARY + queryString,
    "GET",
    null
  );
}

export async function activateAdviceSchoolRequest(params) {
  return await apiCallJson(ACCOUNT_ACTIVATE_ADVICE_SCHOOL + params, "PUT");
}

export async function activateAdviceStudentRequest(params) {
  return await apiCallJson(ACCOUNT_ACTIVATE_ADVICE + params, "PUT");
}

export async function getAllSchoolBarcodes(schoolId, schoolYear) {
  return await apiCallJson(
    SCHOOL_RETURNS_BY_SCHOOL + "?schoolId=" + schoolId + "&year=" + schoolYear,
    "GET"
  );
}

export async function changeSchoolBookStatusParams(params) {
  return await apiCallJson(SCHOOL_SET_BOOK_STATUS + params, "PUT");
}

export async function changeAllSchoolBookStatusParams(params) {
  return await apiCallJson(ALL_SCHOOL_SET_BOOK_STATUS + params, "PUT");
}

export async function addSchoolFlowParams(newFlow) {
  return await apiCallJson(SCHOOL_CREATE_FLOW, "POST", newFlow);
}

export async function addSchoolFlowWithFileParams(newFlow) {
  return await apiCallJsonWithFile(SCHOOL_CREATE_FLOW, "POST", newFlow);
}

export async function deleteSchoolFlowParams(params) {
  return await apiCallJson(
    SCHOOL_DELETE_FLOW + objectToQueryString(params, true),
    "DELETE"
  );
}

export async function getSchoolSettings(schoolId) {
  return await apiCallJson(`${SCHOOL_SETTINGS_ENDPOINT}?schoolId=${schoolId}`, "GET")
}

export async function postSchoolSettings(schoolId, body) {
  const finalBody = { ...body, schoolId: schoolId };

  return await apiCallJson(
    SCHOOL_SETTINGS_ENDPOINT,
    "POST",
    finalBody
  );
}